import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Skeleton placeholder for content that is loading.
 * Renders an animated pulsing bar that matches the layout of expected content.
 * Keyframes defined in packages/ui/src/styles.css (sam-skeleton-pulse).
 */
export const Skeleton = ({ width = '100%', height = '1rem', borderRadius = 'var(--sam-radius-sm)', style, className, }) => {
    return (_jsx("div", { className: `bg-surface ${className ?? ''}`, "aria-hidden": "true", style: {
            width,
            height,
            borderRadius,
            animation: 'sam-skeleton-pulse 1.5s ease-in-out infinite',
            ...style,
        } }));
};
/**
 * A skeleton card matching the typical workspace/node card layout.
 */
export const SkeletonCard = ({ lines = 3, style }) => {
    return (_jsxs("div", { className: "border border-border-default rounded-md p-4 bg-surface flex flex-col gap-3", "aria-hidden": "true", style: style, children: [_jsxs("div", { className: "flex justify-between items-center", children: [_jsx(Skeleton, { width: "60%", height: "1.25rem" }), _jsx(Skeleton, { width: "60px", height: "1.25rem", borderRadius: "9999px" })] }), Array.from({ length: lines }, (_, i) => (_jsx(Skeleton, { width: i === lines - 1 ? '40%' : '80%', height: "0.875rem" }, i)))] }));
};
/**
 * Render multiple skeleton items as a list.
 */
export const SkeletonList = ({ count = 3, variant = 'card', style, }) => {
    return (_jsx("div", { className: "flex flex-col gap-4", "aria-hidden": "true", "aria-label": "Loading content", style: style, children: Array.from({ length: count }, (_, i) => variant === 'card' ? (_jsx(SkeletonCard, {}, i)) : (_jsx(Skeleton, { height: "2.5rem" }, i))) }));
};
//# sourceMappingURL=Skeleton.js.map